import { DesignProp, LayoutProp } from "../PropCategories";

export const gap = {
  prop: "style-attribute",
  name: "Space between",
  nameI18n: "builder_ui.prop_type.styles.space_between_items",
  category: [DesignProp, LayoutProp],
  type: "slider",
  defaultValue: "16",
  sliderProps: {
    units: ["px", "rem", "%"],
    step: 0.25,
    min: 0,
    max: 100,
    defaultUnit: "px",
  },
} as const;
